import "./PopularPlans.css";
import React, { useState, useEffect, useRef } from "react";
import "./Global.js";
import useAppImages from "./components/AppImages";
import { useConfigsQuery } from "./components/queries";

const strapiServerUrl = window.strapiServerUrl;

export default function PopularPlans() {
  const mobileContainerRef = useRef(null);
  const desktopContainerRef = useRef(null);

  const [attributesData, setAttributesData] = useState([]);
  const { loading, error, data } = useConfigsQuery();
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [bundleTypes, setBundleTypes] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [iconData, setIconData] = useState({});

  const [filteredBundles, setFilteredBundles] = useState([]);
  const [openMobileMenu, setOpenMobileMenu] = useState(null);
  // eslint-disable-next-line
  const [appImages, sectionDesc] = useAppImages();
  const [popularImage, setPopularImage] = useState(null);
  const [plansTaxType, setPlansTaxType] = useState(null);


  //To set Scrollbar only visible when its overflowing
  useEffect(() => {
    if (filteredBundles) {
      const popularPlansItems = document.querySelector(".popular_plans--items");
      if (popularPlansItems) {
        if (popularPlansItems.scrollWidth > popularPlansItems.clientWidth) {
          popularPlansItems.classList.add("overflowing");
        } else {
          popularPlansItems.classList.remove("overflowing");
        }
      }
    }
  }, [filteredBundles]);

  useEffect(() => {
    if (appImages) {
      setPopularImage(appImages["popular_plans"]);
    }
  }, [appImages]);

  // Function to toggle the mobile menu visibility
  const handleMobileMenuToggle = (bundleType) => {
    if (openMobileMenu === bundleType) {
      setOpenMobileMenu(null);
    } else {
      setOpenMobileMenu(bundleType);
    }
    mobileContainerRef.current.scrollLeft = 0;
  };

  const handleBundleSelect = (type) => {
    setSelectedBundle(type);
    const filteredBundles = attributesData?.filter(
      (item) =>
        item.attributes?.bundle_type?.data?.attributes?.bundle_type_name === type
    );
    filteredBundles.sort((a, b) => a.attributes.display_order - b.attributes.display_order);
    setFilteredBundles(filteredBundles);
    setPlansTaxType(filteredBundles[0].attributes.bundle_type.data.attributes.tax_type);
   
    //Extracting sub categories
   categories.forEach((category) => {
      if (category.type === type) {
        const catType = category?.subCategory
        ? Object.values(category.subCategory)
        : [];
        setSubCategory(catType);
        if (catType.length > 0) {
          setSelectedCategory(catType[0]);
          const finalBundles = filteredBundles?.filter(
            (item) => item.attributes.sub_category === catType[0]
          );
          setFilteredBundles(finalBundles);
        } else {
          setSelectedCategory(null);
        }
        return;
      }
    });
    desktopContainerRef.current.scrollLeft = 0;
  };

  const handleCategorySelect = (type) => {
    setSelectedCategory(type);
    const finalBundles = attributesData?.filter(
      (item) => item.attributes.sub_category === type
    );
    finalBundles.sort((a, b) => a.attributes.display_order - b.attributes.display_order);
    setFilteredBundles(finalBundles);
    desktopContainerRef.current.scrollLeft = 0;
    mobileContainerRef.current.scrollLeft = 0;
  };

  const updateAttributesData = (bundles, appIcons, types) => {
    if (bundles && appIcons && types) {
      const iconMap = {};
      appIcons.forEach((icon) => {
        iconMap[icon.attributes.icon_code] = {
          value: icon.attributes.icon_name,
          icon: icon.attributes.icon_image.data.attributes.url,
        };
      });
      setIconData(iconMap);
      setAttributesData(bundles);
      //Extracting Bundles Types
      const bundlesTypes = [];
      const categories = [];
       types.forEach((type) => {
        const category = {};
        bundlesTypes.push(type?.attributes?.bundle_type_name);
        category.type = type?.attributes?.bundle_type_name;
          category.subCategory =
          type?.attributes?.sub_category;
          categories.push(category);
      });
      setBundleTypes(bundlesTypes);
      setSelectedBundle(bundlesTypes[0]);
      setCategories(categories);
      setPlansTaxType(types[0].attributes.tax_type);

      //Filtering Bundles
      const filteredBundles = bundles?.filter(
        (item) =>
          item.attributes.bundle_type.data.attributes.bundle_type_name ===
          bundlesTypes[0]
      );
      filteredBundles.sort((a, b) => a.attributes.display_order - b.attributes.display_order);
      setFilteredBundles(filteredBundles);
      //Extracting sub categories
       categories.forEach((category) => {
        if (category.type === bundlesTypes[0]) {
          const catType = category?.subCategory
      ? Object.values(category.subCategory)
      : [];
          setSubCategory(catType);
          if (catType.length > 0) {
            setSelectedCategory(catType[0]);
            const finalBundles = filteredBundles?.filter(
              (item) => item.attributes.sub_category === catType[0]
            );
            setFilteredBundles(finalBundles);
          }
          return;
        }
      }); 
     
    }
  };

  useEffect(() => {
    if (data) {
      const appIcons = data.appIcons.data;
      const bundles = data.bundles.data;
      const bundleTypes = data.bundleTypes.data;
      const currentDate = new Date();

      // Filter bundles based on start_date and end_date
      const activeBundles = bundles.filter((bundle) => {
        const startDate = new Date(bundle.attributes.start_date);
        const endDate = new Date(bundle.attributes.end_date);
        return startDate <= currentDate && endDate >= currentDate;
      });
      updateAttributesData(activeBundles, appIcons, bundleTypes);
    }
  }, [data]);

  const BundleItem = ({ item }) => (
    <div
      className={`popular_plans--item ${
        item.attributes.featured === true ? "popular_plans--featured" : ""
      }`}
      key={item.id}
    >
      <div className="popular_plans--item-content">
        <h2>{item.attributes.bundle_name_en}</h2>
        <div className="popular_card-middle-section">
          {Object.entries(item.attributes.bundle_attributes).map(
            ([key, value]) => (
              <div className="plan_section" key={key}>
                <div className="plan_icon">
                  <img
                    src={`${strapiServerUrl}${iconData[key].icon}`}
                    alt={iconData[key].value}
                  />
                </div>
                <div className="plan_pack">
                  <h3>{value}</h3>
                </div>
              </div>
            )
          )}
          <div className="plan_section">
            <div className="plan_icon">
              <img src={`${strapiServerUrl}${iconData[2].icon}`} alt="icon" />
            </div>
            <div className="plan_pack">
              <h3>{item.attributes.validity}</h3>
            </div>
          </div>
        </div>
        <div className="popular_card-last-section">
          <h3>{item.attributes.price}</h3>
          <span className="plan_span">{item.attributes.ussd_code}</span>
        </div>
      </div>
    </div>
  );

  const MenuItems = ({
    bundleTypes,
    selectedType,
    handleTypeSelect,
    className,
  }) => (
    <ul className={className}>
      {bundleTypes.map((bundleType) => (
        <li key={bundleType}>
          <div
            className={`popular_menu-link  ${
              selectedType === bundleType ? "selected" : ""
            }`}
            style={{
              cursor: selectedType !== bundleType ? "pointer" : "default",
            }}
            onClick={() => {
              if (bundleType !== selectedType) {
                handleTypeSelect(bundleType);
              }
            }}
          >
            {bundleType}
          </div>
        </li>
      ))}
    </ul>
  );

  return (
    <div className="popular_plans--container" id="popular-plans">
      <div className="popular_plans--title">
        <h1>Popular Plans</h1>
      </div>
      <section className="popular_plans_section">
        <div className="popular_plans_image">
          {popularImage && (
            <img src={`${strapiServerUrl}${popularImage}`} alt="" />
          )}
        </div>
        <div className="popular_mobile-menus">
          {bundleTypes &&
            bundleTypes.map((bundleType) => (
              <div className="popular_mobile_plans" key={bundleType}>
                <div
                  className="mobile_menubar"
                  onClick={() => {
                    handleMobileMenuToggle(bundleType);
                    if (openMobileMenu !== bundleType) {
                      handleBundleSelect(bundleType);
                    }
                  }}
                >
                  <h2 className="mobile_menu">{bundleType}</h2>
                  <div  className="icon-link">
                    <i
                      className={`${
                        openMobileMenu === bundleType
                          ? "fas fa-arrow-up"
                          : "fas fa-arrow-down"
                      }`}
                    ></i>
                  </div>
                </div>
                {bundleType === openMobileMenu && subCategory && (
                  <MenuItems
                    bundleTypes={subCategory}
                    selectedType={selectedCategory}
                    handleTypeSelect={handleCategorySelect}
                    className="popular_plans--mobile--category"
                  />
                )}
                <div
                  ref={mobileContainerRef}
                  className={`popular_plans_mobile--items--container ${
                    openMobileMenu === bundleType ? "show_mobile_plans" : ""
                  }`}
                >
                  {loading ? (
                    <div>Loading...</div>
                  ) : error ? (
                    <div>Error: {error.message}</div>
                  ) : (<div className="popular_plans_mobile--items">
                    {filteredBundles &&
                    filteredBundles.map((item) => (
                      <BundleItem key={item.id} item={item} />
                    ))}
                  </div>)}
                  {plansTaxType && plansTaxType}
                </div>
              </div>
            ))}
        </div>
        <div className="popular_plans_cards">
          {bundleTypes && (
            <MenuItems
              bundleTypes={bundleTypes}
              selectedType={selectedBundle}
              handleTypeSelect={handleBundleSelect}
              className="popular_plans--menu"
            />
          )}
          {subCategory && (
            <MenuItems
              bundleTypes={subCategory}
              selectedType={selectedCategory}
              handleTypeSelect={handleCategorySelect}
              className="popular_plans--menu"
            />
          )}
          <div ref={desktopContainerRef} className="popular_plans--items--container">
            {loading ? (
              <div>Loading...</div>
            ) : error ? (
              <div>Error: {error.message}</div>
            ) : (<div className="popular_plans--items">
            {filteredBundles &&
              filteredBundles.map((item) => (
                <BundleItem key={item.id} item={item} />
              ))}
              </div>
            )}
                  <div className="popular_plans_price--desc"> {plansTaxType && plansTaxType}</div> 
          </div>
        </div>
      </section>
    </div>
  );
}
